import moment from 'moment';
import report, { AttendanceTrackingReportFilter } from '../../../apis/report';

export const fetchAttendanceTrackingReportData = async ({
  school,
  grade,
  division,
  startDate,
  endDate
}: AttendanceTrackingReportFilter) => {
  const response = await report.fetchAttendanceTrackingReport({
    school,
    grade,
    division,
    startDate,
    endDate
  });
  return response;
};

export const transformAttendanceTrackingReportData = (
  attendanceTrackingReportData: any,
  isDownloading: boolean
) => {
  const DATE_FORMAT = 'DD-MMM-YYYY';
  return attendanceTrackingReportData.map((record: any) => {
    const basicData = {
      'Attendance Date': record.attendanceDate
        ? moment(record.attendanceDate).format(DATE_FORMAT)
        : '',
      'Student Name': record.studentDetails ? record.studentDetails.name : '',
      Grade: record.grade ? record.grade : '',
      Division: record.division ? record.division : '',
      'Marked As': record.markedAs ? record.markedAs : '',
      'Marked By': record.markedByUserDetails
        ? record.markedByUserDetails.name
        : 'Marked By Tracker'
    };
    if (!isDownloading) {
      return { id: record.id, ...basicData };
    }
    return basicData;
  });
};
